<div class="tw-flex-1 tw-flex tw-flex-col tw-bg-gray-100 tw-rounded-t-6">
    <div class="tw-px-6 tw-py-9">
        <div
             class="tw-fixed tw-top-5 tw-right-6 tw-rounded-full tw-bg-white tw-h-7 tw-w-7 tw-flex tw-items-center tw-justify-center">
            <cs-icon id="hide-detailed-view-btn"
                     class="tw-w-6 tw-h-6 tw-text-gray-500"
                     [iconName]="'close'"
                     (click)="close()"></cs-icon>
        </div>
        <p class="tw-font-lexend tw-text-500 tw-text-gray-800 tw-mb-10 tw-w-[85%] tw-font-normal"
           i18n="@@climateAffects"> Your area's climate can be a major factor behind your skin or hair concerns. </p>
        <p class="tw-font-body tw-text-100 tw-text-gray-800 tw-uppercase tw-mb-3 tw-tracking-wide"
           i18n="@@forExample"> For eg: </p>
        <div class="tw-flex tw-flex-col tw-gap-2">
            <div class="tw-flex tw-items-center tw-gap-4 tw-p-2 tw-bg-gray-50 tw-rounded-[10px]">
                <img alt="banglore" src="https://cdn.cureskin.com/app/img/bangalore_v1.svg" />
                <p class="tw-font-lexend tw-text-300 tw-text-gray-800 tw-w-3/5"
                   i18n="@@bangloreHardWater"> Bangalore's hard water can cause heavy hair fall </p>
            </div>
            <div class="tw-flex tw-items-center tw-gap-4 tw-p-2 tw-bg-gray-50 tw-rounded-[10px]">
                <img alt="delhi" src="https://cdn.cureskin.com/app/img/delhi_v1.svg" />
                <p class="tw-font-lexend tw-text-300 tw-text-gray-800 tw-w-[70%]"
                   i18n="@@delhiPollution">Delhi’s pollution is a major factor behind pigmentation</p>
            </div>
            <div class="tw-flex tw-items-center tw-gap-4 tw-p-2 tw-bg-gray-50 tw-rounded-[10px]">
                <img alt="mumbai" src="https://cdn.cureskin.com/app/img/mumbai_v1.svg" />
                <p class="tw-font-lexend tw-text-300 tw-text-gray-800 tw-w-[70%]"
                   i18n="@@mumbaisHeavy"> Mumbai's heavy monsoons can trigger acne problems </p>
            </div>
        </div>
    </div>


    <footer
            class="tw-h-[calc(112px+48px+24px)] tw-pt-6 tw-px-6 tw-flex tw-flex-col tw-items-stretch tw-rounded-t-5">
        <button csButton
                id="location-btn"
                type="button"
                class="tw-w-full tw-mt-[5px] tw-relative proceed"
                (click)="getLocation()"> <span i18n="@@userYourLocation">Use Your Location</span>
        </button>
        <button csButton="muted"
                id="continue-btn"
                type="button"
                class="tw-w-full tw-mt-[5px] tw-relative proceed"
                (click)="continue()"><span i18n="@@noThanksNew">No, Thanks</span>
        </button>
    </footer>
</div>